import React, { Component } from "react";

import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import { isDesktop } from "react-device-detect";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

import StringInput from "../../components/Input/StringInput/StringInput";
import SecurityAns from "./MobileEditPage/SecurityAns";
import { formValidation } from "../../hoc/Shared/utility";

import { setSecurityQuestion, getSecurityQuestion, updateSecurityQuestion } from "../../store/ducks/profile/actions";

export class EditSecurityAns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,

            checkAns1: "",
            checkAns2: "",
            checkAns3: "",
            checkAns4: "",
            checkAns5: "",
            status: "insert",

            newQuestion1: "",
            newQuestion2: "",
            newQuestion3: "",
            newQuestion4: "",
            newQuestion5: "",
            newAns1: "",
            newAns2: "",
            newAns3: "",
            newAns4: "",
            newAns5: "",
            newSecuritySetting: [
                { id: 1, question: "", ans: "" },
                { id: 2, question: "", ans: "" },
                { id: 3, question: "", ans: "" },
                { id: 4, question: "", ans: "" },
                { id: 5, question: "", ans: "" },
            ],

            confirmAns1: "",
            confirmAns2: "",
            confirmAns3: "",
            confirmAns4: "",
            confirmAns5: "",
        };
    }

    componentDidMount() {
        formValidation("setSecurityQuestionForm");

        const data = {};
        data.agent_id = this.props.currentUser.data.id;

        this.props.getSecurityQuestion(data);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;

        if (nextProps.set_security_question_result !== this.props.set_security_question_result) {
            if (nextProps.set_security_question_result.responseCode === 200) {
                const { t } = this.props;

                if (isDesktop) {
                    Swal.fire({
                        title: t("global.success"),
                        text: t("global.record-updated"),
                        icon: "success",
                        confirmButtonText: t("global.ok"),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();

                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                        title: t("global.success"),
                        icon: "success",
                        text: t("global.record-updated"),
                        confirmButtonText: t("global.ok"),
                        customClass: {
                            container: "swal-mobile-container sucess",
                            icon: "swal-success-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                current_password: "",
                                new_password: "",
                                confirm_password: "",
                                touched: false,
                                errorMsg: [],
                            });

                            Swal.close();

                            window.location.reload();
                        }
                    });
                }
            } else if (nextProps.set_security_question_result.responseCode === 422) {
                if (!isDesktop) {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.set_security_question_result.message[0],
                        customClass: {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                touched: true,
                                errorMsg: nextProps.set_security_question_result.message || [],
                                formError: true,
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.set_security_question_result.message,
                        customClass: !isDesktop
                            ? {
                                  container: "swal-mobile-container sorry",
                                  icon: "swal-sorry-icon",
                              }
                            : [],
                    });
                }
            } else {
                return false;
            }
        }

        if (nextProps.update_security_question_result !== this.props.update_security_question_result) {
            if (nextProps.update_security_question_result.responseCode === 200) {
                const { t } = this.props;

                if (isDesktop) {
                    Swal.fire({
                        title: t("global.success"),
                        text: t("global.record-updated"),
                        icon: "success",
                        confirmButtonText: t("global.ok"),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();

                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                        title: t("global.success"),
                        icon: "success",
                        text: t("global.record-updated"),
                        confirmButtonText: t("global.ok"),
                        customClass: {
                            container: "swal-mobile-container sucess",
                            icon: "swal-success-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                current_password: "",
                                new_password: "",
                                confirm_password: "",
                                touched: false,
                                errorMsg: [],
                            });

                            Swal.close();

                            window.location.reload();
                        }
                    });
                }
            } else if (nextProps.update_security_question_result.responseCode === 422) {
                if (!isDesktop) {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.update_security_question_result.message[0],
                        customClass: {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                touched: true,
                                errorMsg: nextProps.update_security_question_result.message || [],
                                formError: true,
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.update_security_question_result.message,
                        customClass: !isDesktop
                            ? {
                                  container: "swal-mobile-container sorry",
                                  icon: "swal-sorry-icon",
                              }
                            : [],
                    });
                }

                // }
            } else {
                return false;
            }
        }

        if (nextProps.get_security_question_result !== this.props.get_security_question_result) {
            if (nextProps.get_security_question_result.responseCode === 200) {
                if (nextProps.get_security_question_result.data) {
                    this.setState({
                        checkAns1: nextProps.get_security_question_result.data.security_question_one_ans,
                        checkAns2: nextProps.get_security_question_result.data.security_question_two_ans,
                        checkAns3: nextProps.get_security_question_result.data.security_question_three_ans,
                        checkAns4: nextProps.get_security_question_result.data.security_question_four_ans,
                        checkAns5: nextProps.get_security_question_result.data.security_question_five_ans,
                        status: "update",
                    });
                }
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.get_security_question_result.data.message[0],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        return true;
    }

    //** component**
    stepSecurityCheck = (props) => {
        const { t } = this.props;

        return (
            <form
                id="setSecurityQuestionForm"
                name="setSecurityQuestionForm"
                className="forms-col needs-validation form-security-ans mt-4"
                noValidate
                onSubmit={props.status === "insert" ? (e) => props.setSecurityQuestionHandler(e) : (e) => props.updateSecurityQuestionHandler(e)}
                method="post"
            >
                {props.questions &&
                    props.questions.map((item, index) => (
                        <div key={index}>
                            <div className="input-group left has-validation mb-2">
                                <p className="input-text readonly w-auto">{t("validation.question")} {item.id}</p>
                                <StringInput className="form-control" name="securityQues" value={item.question} readOnly />
                            </div>
                            <div className="input-group  has-validation mb-2">
                                <p className="input-text">{t("validation.answer")}</p>
                                <StringInput
                                    // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                                    className="form-control"
                                    type="text"
                                    placeholder={t("validation.insert-security-ans")}
                                    name="securityAns"
                                    defaultValue=""
                                    value={props["checkAns" + item.id]}
                                    onChange={(e) => props.updateSecurityCheckAns(e, item.id)}
                                    // minLength={contact_no_min_limits}
                                    // maxLength={contact_no_max_limits}
                                    // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                    // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                    required
                                    requiredMessage={t("validation.required")}
                                    // errorMsg={this.props.errorMsg.mobile_no || ""}
                                    // formError={this.props.formError}
                                />
                            </div>
                        </div>
                    ))}
                <button className="btn btn-gradient-blue w-25" type="submit" form="setSecurityQuestionForm">
                {t("global.save")}
                </button>
            </form>
        );
    };

    stepSecuritySetting = (props) => {
        const { t } = this.props;
        return (
            <>
                <div className="text-danger d-flex align-items-start my-2">
                    <span style={{ width: "0.75rem", height: "0.75rem" }}>
                        <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
                    </span>
                    <span>{t("validation.length-20")}</span>
                </div>
                <form className="forms-col needs-validation form-security-ans" onSubmit={props.updateSecuritySetting}>
                    {props.newSecuritySetting &&
                        props.newSecuritySetting.map((item, index) => (
                            <div key={index}>
                                <div className="input-group left has-validation mb-2">
                                    <p className="input-text w-auto">{t("validation.question")}  {item.id}</p>
                                    <StringInput
                                        // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                                        className="form-control"
                                        type="text"
                                        placeholder={t("validation.insert-security-ans")}
                                        name="securityQues"
                                        defaultValue=""
                                        value={props["newQuestion" + item.id]}
                                        onChange={(e) => props.updateNewSecurityQuestion(e, item.id)}
                                        // minLength={contact_no_min_limits}
                                        // maxLength={contact_no_max_limits}
                                        // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                        // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                        required
                                        // requiredMessage={t("validation.required")}
                                        // errorMsg={this.props.errorMsg.mobile_no || ""}
                                        // formError={this.props.formError}
                                    />
                                </div>
                                <div className="input-group left has-validation mb-2">
                                    <p className="input-text">{t("validation.answer")}</p>
                                    <StringInput
                                        // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                                        className="form-control"
                                        type="text"
                                        placeholder={t("validation.insert-security-ans")}
                                        name="securityAns"
                                        defaultValue=""
                                        value={props["newAns" + item.id]}
                                        onChange={(e) => props.updateNewSecurityAns(e, item.id)}
                                        // minLength={contact_no_min_limits}
                                        // maxLength={contact_no_max_limits}
                                        // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                        // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                        required
                                        // requiredMessage={t("validation.required")}
                                        // errorMsg={this.props.errorMsg.mobile_no || ""}
                                        // formError={this.props.formError}
                                    />
                                </div>
                            </div>
                        ))}
                    <button className="btn btn-gradient-blue w-25" type="submit" disabled={false}>
                    {t("game-page.new")}
                    </button>
                </form>
            </>
        );
    };

    stepSecurityConfirmation = (props) => {
        const { t } = this.props;
        return (
            <>
                <div className="text-danger d-flex align-items-start my-2">
                    <span style={{ width: "0.75rem", height: "0.75rem" }}>
                        <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
                    </span>
                    <span>{t("validation.length-20")}</span>
                </div>
                <form className="forms-col needs-validation form-security-ans">
                    {props.questions &&
                        props.questions.map((item, index) => (
                            <div key={index}>
                                <div className="input-group left has-validation mb-2">
                                    <p className="input-text readonly w-auto">{t("validation.question")}  {item.id}</p>
                                    <StringInput className="form-control" name="securityQues" value={item.question} readOnly />
                                </div>
                                <div className="input-group left has-validation mb-2">
                                    <p className="input-text">{t("validation.answer")}</p>
                                    <StringInput
                                        // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                                        className="form-control"
                                        type="text"
                                        placeholder={t("validation.insert-security-ans")}
                                        name="securityAns"
                                        defaultValue=""
                                        value={props["confirmAns" + item.id]}
                                        onChange={(e) => props.updateConfirmAns(e, item.id)}
                                        // minLength={contact_no_min_limits}
                                        // maxLength={contact_no_max_limits}
                                        // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                        // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                        required
                                        // requiredMessage={t("validation.required")}
                                        // errorMsg={this.props.errorMsg.mobile_no || ""}
                                        // formError={this.props.formError}
                                    />
                                </div>
                            </div>
                        ))}
                    <div className="d-flex">
                        <button className="btn btn-outline-blue w-25 me-2" type="submit" onClick={props.backtoPrevStep}>
                        {t("global.back")}
                        </button>
                        <button className="btn btn-gradient-blue w-25" type="submit" onClick={props.confirmationUpdateSetting}>
                        {t("game-page.new")}
                        </button>
                    </div>
                </form>
            </>
        );
    };

    //** Function **

    updateSecurityCheckAns = (e, id) => {
        if (id === 1) {
            this.setState({
                checkAns1: e.target.value,
            });
        } else if (id === 2) {
            this.setState({
                checkAns2: e.target.value,
            });
        } else if (id === 3) {
            this.setState({
                checkAns3: e.target.value,
            });
        } else if (id === 4) {
            this.setState({
                checkAns4: e.target.value,
            });
        } else if (id === 5) {
            this.setState({
                checkAns5: e.target.value,
            });
        }
    };

    updateNewSecurityAns = (e, id) => {
        if (id === 1) {
            this.setState({
                newAns1: e.target.value,
            });
        } else if (id === 2) {
            this.setState({
                newAns2: e.target.value,
            });
        } else if (id === 3) {
            this.setState({
                newAns3: e.target.value,
            });
        }
    };

    updateNewSecurityQuestion = (e, id) => {
        if (id === 1) {
            this.setState({
                newQuestion1: e.target.value,
            });
        } else if (id === 2) {
            this.setState({
                newQuestion2: e.target.value,
            });
        } else if (id === 3) {
            this.setState({
                newQuestion3: e.target.value,
            });
        }
    };

    updateSecuritySetting = (e) => {
        e.preventDefault();

        let newSecuritySetting = this.state.newSecuritySetting;
        for (let i = 0; i < newSecuritySetting.length; i++) {
            const n = i + 1;
            newSecuritySetting[i].ans = this.state["newAns" + n];
            newSecuritySetting[i].question = this.state["newQuestion" + n];
        }

        this.gotoNextStep();
        console.log(newSecuritySetting);
    };

    updateConfirmAns = (e, id) => {
        if (id === 1) {
            this.setState({
                confirmAns1: e.target.value,
            });
        } else if (id === 2) {
            this.setState({
                confirmAns2: e.target.value,
            });
        } else if (id === 3) {
            this.setState({
                confirmAns3: e.target.value,
            });
        }
    };

    confirmationUpdateSetting = (e) => {
        const { t } = this.props;
        e.preventDefault();
        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : "",
            icon: "warning",
            title: t("global.reminder"),
            text: t("profile.security-msg"),
            // showConfirmButton: true,
            confirmButtonText: t("global.confirm"),
            showCancelButton: true,
            cancelButtonText: t("global.verify-again"),
            customClass: isDesktop
                ? {
                      popup: "mw-100",
                  }
                : {
                      container: "swal-mobile-container reminder",
                      icon: "swal-reminder-icon",
                  },
        }).then((result) => {
            if (result.isConfirmed) {
                console.log("Updated Setting");
            }
        });
    };

    backtoPrevStep = () => {
        this.setState({
            currentStep: this.state.currentStep - 1,
        });
    };
    gotoNextStep = () => {
        this.setState({
            currentStep: this.state.currentStep + 1,
        });
    };

    updateSecurityQuestionHandler = (e) => {
        const { t } = this.props;
        e.preventDefault();

        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};
                    data.security_question_one = 1;
                    data.security_question_one_ans = this.state.checkAns1;
                    data.security_question_two = 2;
                    data.security_question_two_ans = this.state.checkAns2;
                    data.security_question_three = 3;
                    data.security_question_three_ans = this.state.checkAns3;
                    data.security_question_four = 4;
                    data.security_question_four_ans = this.state.checkAns4;
                    data.security_question_five = 5;
                    data.security_question_five_ans = this.state.checkAns5;
                    data.agent_id = this.props.currentUser.data.id;

                    this.props.updateSecurityQuestion(data);
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};
                    data.security_question_one = 1;
                    data.security_question_one_ans = this.state.checkAns1;
                    data.security_question_two = 2;
                    data.security_question_two_ans = this.state.checkAns2;
                    data.security_question_three = 3;
                    data.security_question_three_ans = this.state.checkAns3;
                    data.security_question_four = 4;
                    data.security_question_four_ans = this.state.checkAns4;
                    data.security_question_five = 5;
                    data.security_question_five_ans = this.state.checkAns5;
                    data.agent_id = this.props.currentUser.data.id;

                    this.props.updateSecurityQuestion(data);
                }
            });
        }
    };

    setSecurityQuestionHandler = (e) => {
        const { t } = this.props;
        e.preventDefault();

        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};
                    data.security_question_one = 1;
                    data.security_question_one_ans = this.state.checkAns1;
                    data.security_question_two = 2;
                    data.security_question_two_ans = this.state.checkAns2;
                    data.security_question_three = 3;
                    data.security_question_three_ans = this.state.checkAns3;
                    data.security_question_four = 4;
                    data.security_question_four_ans = this.state.checkAns4;
                    data.security_question_five = 5;
                    data.security_question_five_ans = this.state.checkAns5;
                    data.agent_id = this.props.currentUser.data.id;

                    this.props.setSecurityQuestion(data);
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};
                    data.security_question_one = 1;
                    data.security_question_one_ans = this.state.checkAns1;
                    data.security_question_two = 2;
                    data.security_question_two_ans = this.state.checkAns2;
                    data.security_question_three = 3;
                    data.security_question_three_ans = this.state.checkAns3;
                    data.security_question_four = 4;
                    data.security_question_four_ans = this.state.checkAns4;
                    data.security_question_five = 5;
                    data.security_question_five_ans = this.state.checkAns5;
                    data.agent_id = this.props.currentUser.data.id;

                    this.props.setSecurityQuestion(data);
                }
            });
        }
    };

    render() {
        const { t } = this.props;

        const fadeUp = keyframes`
    from {
    opacity: 0;
    transform: translate3d(0, 50px ,0);
    }

    to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    }
`;

        const steps = [
            { id: 1, label: "Security Check" },
            { id: 2, label: "Security Setting" },
            { id: 3, label: "Security Confirmation" },
        ];

        const questions = [
            { id: 1, question: t("security-question.question-1") },
            { id: 2, question: t("security-question.question-2") },
            { id: 3, question: t("security-question.question-3") },
            { id: 4, question: t("security-question.question-4") },
            { id: 5, question: t("security-question.question-5") },
        ];

        return (
            <>
                {isDesktop ? (
                    <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                        <div className="row g-3">
                            <div className="col-12">
                                <div className="pd-card-col h-100">
                                    <div className="d-flex align-items-center mb-5">
                                        <button className="me-2 btn" onClick={this.props.backToPersonalDetails}>
                                            <Icon icon="material-symbols:arrow-back-ios-rounded" />
                                        </button>
                                        <h4 className="mb-0">{t("validation.edit-sec-ans")}</h4>
                                    </div>

                                    <div className="pd-content px-5">
                                        <div className="step-progress-bar mb-5">
                                            {steps &&
                                                steps.map((item, index) => (
                                                    <>
                                                        <div
                                                            key={index}
                                                            className={`step ${item.id < this.state.currentStep ? "completed" : item.id === this.state.currentStep ? "active" : ""}
                        `}
                                                        >
                                                            {item.id < this.state.currentStep ? (
                                                                <p className="step-done">
                                                                    <Icon icon="ic:baseline-check" />
                                                                </p>
                                                            ) : (
                                                                <p className="step-num">{item.id}</p>
                                                            )}
                                                            <p className="step-title">{item.label}</p>
                                                        </div>

                                                        {index + 1 !== steps.length && <hr className={`${item.id < this.state.currentStep && "active"}`} />}
                                                    </>
                                                ))}
                                        </div>

                                        <div className="px-3">
                                            <p>
                                            {t("validation.tips-2")}
                                            </p>

                                            {this.state.currentStep === 1 ? (
                                                <this.stepSecurityCheck
                                                    {...this.state}
                                                    gotoNextStep={this.gotoNextStep}
                                                    questions={questions}
                                                    updateSecurityCheckAns={this.updateSecurityCheckAns}
                                                    setSecurityQuestionHandler={this.setSecurityQuestionHandler}
                                                    updateSecurityQuestionHandler={this.updateSecurityQuestionHandler}
                                                />
                                            ) : this.state.currentStep === 2 ? (
                                                <this.stepSecuritySetting
                                                    {...this.state}
                                                    newSecuritySetting={this.state.newSecuritySetting}
                                                    gotoNextStep={this.gotoNextStep}
                                                    updateNewSecurityQuestion={this.updateNewSecurityQuestion}
                                                    updateNewSecurityAns={this.updateNewSecurityAns}
                                                    updateSecuritySetting={this.updateSecuritySetting}
                                                />
                                            ) : this.state.currentStep === 3 ? (
                                                <this.stepSecurityConfirmation
                                                    {...this.state}
                                                    newSecurityAns={this.state.newSecurityAns}
                                                    questions={this.state.newSecuritySetting}
                                                    gotoNextStep={this.gotoNextStep}
                                                    backtoPrevStep={this.backtoPrevStep}
                                                    updateConfirmAns={this.updateConfirmAns}
                                                    confirmationUpdateSetting={this.confirmationUpdateSetting}
                                                />
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                ) : (
                    <SecurityAns
                        {...this.state}
                        backToPersonalDetails={this.props.backToPersonalDetails}
                        backtoPrevStep={this.backtoPrevStep}
                        gotoNextStep={this.gotoNextStep}
                        updateSecurityCheckAns={this.updateSecurityCheckAns}
                        updateNewSecurityQuestion={this.updateNewSecurityQuestion}
                        updateNewSecurityAns={this.updateNewSecurityAns}
                        updateSecuritySetting={this.updateSecuritySetting}
                        updateConfirmAns={this.updateConfirmAns}
                        confirmationUpdateSetting={this.confirmationUpdateSetting}
                        setSecurityQuestionHandler={this.setSecurityQuestionHandler}
                        updateSecurityQuestionHandler={this.updateSecurityQuestionHandler}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { profile } = state;

    return {
        currentUser: state.currentUser,
        set_security_question_result: profile.set_security_question_result,
        get_security_question_result: profile.get_security_question_result,
        update_security_question_result: profile.update_security_question_result,
    };
};

const mapDispatchToProps = {
    setSecurityQuestion,
    getSecurityQuestion,
    updateSecurityQuestion,
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(EditSecurityAns));
